/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Eyebrow_CustomInputs */

const en_us2_plan_eyebrow_custom = /** @type {(inputs: Plan_Eyebrow_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom plan`)
};

const pt_br2_plan_eyebrow_custom = /** @type {(inputs: Plan_Eyebrow_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano personalizado`)
};

const es_419_plan_eyebrow_custom = /** @type {(inputs: Plan_Eyebrow_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan personalizado`)
};

const pt_pt2_plan_eyebrow_custom = /** @type {(inputs: Plan_Eyebrow_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano personalizado`)
};

const fr_fr2_plan_eyebrow_custom = /** @type {(inputs: Plan_Eyebrow_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme personnalisé`)
};

const de_de2_plan_eyebrow_custom = /** @type {(inputs: Plan_Eyebrow_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigener Plan`)
};

const it_it2_plan_eyebrow_custom = /** @type {(inputs: Plan_Eyebrow_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda personalizzata`)
};

/**
* | output |
* | --- |
* | "Custom plan" |
*
* @param {Plan_Eyebrow_CustomInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_eyebrow_custom = /** @type {((inputs?: Plan_Eyebrow_CustomInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Eyebrow_CustomInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_eyebrow_custom(inputs)
	if (locale === "es-419") return es_419_plan_eyebrow_custom(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_eyebrow_custom(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_eyebrow_custom(inputs)
	if (locale === "de-DE") return de_de2_plan_eyebrow_custom(inputs)
	if (locale === "it-IT") return it_it2_plan_eyebrow_custom(inputs)
	return en_us2_plan_eyebrow_custom(inputs)
});
export { plan_eyebrow_custom as "plan.eyebrow_custom" }